import React, { useEffect } from "react";
import { Text2xl, TextLg, TextMd, TextSm } from "../../components/text";
import { useAppContext } from "../../context/appContext";
import { SeeMore } from "../home/components/seeMore";
import { FullStackApplications } from "./components/fullStackApplications";
import { ApiDevelopment } from "./components/apiDevelopment";
import { CloudArchitecture } from "./components/cloudArchitecture";
import { FadeInSection } from "../../components/fadeInSection/fadeInSection";
import { ImageContainer } from "../../components/imageContainer";

export const WebDevelopment = () => {
  const { routing, setPageLoading } = useAppContext();
  const { navigate } = routing;

  useEffect(()=>{
    setPageLoading(true);
  },[]);

  return (
    <div className="bg-blue-50">
      <div className="relative flex flex-col overflow-hidden">
        <ImageContainer
          url="/images/workspace.png"
          onLoad={()=>{
            setPageLoading(false);
          }}
        />

        <div className="absolute inset-0 backdrop-blur-[6px] flex items-center justify-center text-gray-100 bg-black/25">
          <div className="flex flex-col items-center gap-3 text-center px-9">
            <Text2xl className="font-bold select-none">
              Web Development
            </Text2xl>

            <TextMd className="font-medium max-w-2xl text-center select-none text-slate-200">
              Modern web applications, scalable APIs, and cloud-ready systems
              built for performance, usability, and growth.
            </TextMd>
          </div>
        </div>
      </div>

      <div className="p-9 flex flex-col items-center">
        <TextMd className="flex flex-wrap items-center justify-center gap-x-1.5 lg:gap-x-2  *:my-auto">
          <TextLg className="font-bold bg-gradient-to-r from-blue-500 via-cyan-500 to-blue-600 bg-clip-text text-transparent">
            Building
          </TextLg>

          <span>software</span> 
          <span>that</span> 
          <span>is</span> 
          <span>fast,</span>
          <span>scalable,</span>
          <span>and</span> 
          <span>production-ready.</span>
        </TextMd>

        <TextSm className="text-slate-500 leading-7 mt-4 font-medium max-w-[80%] text-center">
          Web development solutions focused on clean user experiences, reliable
          backend systems, and cloud architecture that supports real business
          growth.
        </TextSm>
      </div>

      <div className="flex flex-col">
        
        <FadeInSection left threshold={0.25} className="m-1">
          <FullStackApplications className="p-9" />
        </FadeInSection>
        
        <div className="h-px mx-9 bg-neutral-500/15" />
        <FadeInSection left threshold={0.25} className="m-1">
          <ApiDevelopment className="p-9" />
        </FadeInSection>

        <div className="h-px mx-9 bg-neutral-500/15" />
        
        <FadeInSection left threshold={0.25} className="m-1">
          <CloudArchitecture className="p-9" />
        </FadeInSection>
        
      </div>
    </div>
  );
};